import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { generateNewIdAndNavigate } from "../../thunks/dashboardThunks";
import { DEFAULT_PROJECT_NAMES, LAYOUTS } from "../../constants/general";
import { Modal } from "./modal";
import { CategoryDropdown } from "./CategoryDropdown";
import { openCansvasSizeModal } from "../../store/common/profileModalSlice";
import {
  setIsFacelessVideo,
  setIsOnlyAvatar,
  setIsOnlyAvatarUrl,
  setIsDoc,
  setIsLink,
  setIsNonVoice,
  setIsOnlyAIVoice,
  setIsAIdubbingVoice,
} from "../../store/project/projectSlice";
import { Tooltip } from "./Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
} from "@fortawesome/free-solid-svg-icons";

const CreateRailItem = ({
  iconUrl,
  label,
  type = "user-template",
  ...props
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openCategory, setOpenCategory] = useState();

  const onClick = () => {
    if (props.disabled) {
      return;
    }
    if (props.navigate) {
      return navigate(props.navigate);
    }
    dispatch(setIsFacelessVideo(!!props.isFaceless));
    dispatch(setIsDoc(!!props.isDoc));
    dispatch(setIsLink(!!props.isLinkVideo));
    dispatch(setIsNonVoice(!!props.isNonVoice));
    const featureTemplate = type === "template";
    if (featureTemplate) {
      return setOpenCategory(true);
    }
    if (type === "user-template") {
      dispatch(openCansvasSizeModal());
      return;
    }
    if (type === "only-avatar") {
      dispatch(setIsOnlyAvatar(!!props.isOnlyAvatar));
    }

    if (type === "ai-voices") {
      dispatch(setIsOnlyAIVoice(!!props.isOnlyAIVoice));
    }

    // if (type === "ai-dubbing") {
    //   dispatch(setIsAIdubbingVoice(!!props.isAIdubbingVoice));
    // }

    dispatch(
      generateNewIdAndNavigate(
        navigate,
        "/tool/editor/" + type + "/",
        DEFAULT_PROJECT_NAMES[type],
        false,
        featureTemplate,
        null,
        null,
        props.isFaceless,
        props.isOnlyAvatar
        // props.isNonVoice
      )
    );
  };

  const onToggle = () => setOpenCategory((prev) => !prev);

  const onSave = () => {
    onToggle();
    return dispatch(
      generateNewIdAndNavigate(
        navigate,
        "/tool/editor/" + type + "/",
        DEFAULT_PROJECT_NAMES[type],
        true,
        null,
        null,
        null,
        1920,
        1080,
        LAYOUTS.LANDSCAPE
      )
    );
  };
  return (
    <>
      {openCategory && (
        <Modal
          size="lg"
          center
          hideCancelBtn
          open={true}
          onClose={() => onToggle()}
        >
          <CategoryDropdown onClose={onToggle} onSave={onSave} />
        </Modal>
      )}
      <div
        onClick={onClick}
        className={`group relative flex flex-col items-center justify-center p-4 bg-white rounded-lg shadow-md space-y-2 hover:shadow-xl overflow-visible ${
          props.disabled
            ? "opacity-60 cursor-not-allowed"
            : "opacity-100 cursor-pointer"
        } min-w-[177px] h-[136px]`}
      >
        {props.tooltip && (
          <Tooltip className="top-[10%]">{props.tooltip}</Tooltip>
        )}
        <img src={iconUrl} alt={label} className="w-12 h-12" />
        <p className="us text-sm text-vb-label-gray text-center">{label}</p>
      </div>
    </>
  );
};

const CreateRail = ({ items }) => {
  const scrollContainer = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflow = () => {
    if (scrollContainer.current) {
      setIsOverflowing(
        scrollContainer.current.scrollWidth >
          scrollContainer.current.clientWidth
      );
    }
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [items]);

  const scrollRight = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollBy({ left: 150, behavior: "smooth" });
    }
  };

  const scrollLeft = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollBy({ left: -150, behavior: "smooth" });
    }
  };
  return (
    <div className="w-full overflow-hidden mx-4 mr-8 mt-2 pr-2">
      <div className="us text-sm font-weight-400 mb-4">
        Let's create some <b className="text-[#6043DB]">Video&#33;</b>
      </div>
      <div className="relative">
        {isOverflowing && (
          <span
            className="text-gray-400 cursor-pointer mr-2 absolute left-0 top-[50%] translate-y-[-50%] z-10"
            onClick={scrollLeft}
          >
            <FontAwesomeIcon
              icon={faArrowAltCircleLeft}
              className="mr-2 text-gray-800 hover:text-vb-pink "
            />
          </span>
        )}
        <div
          className="flex relative flex-nowrap overflow-x-auto  space-x-4 py-2 pr-4 scroll-container"
          id="scrollableDiv"
          ref={scrollContainer}
        >
          {items.map((item, index) => (
            <CreateRailItem key={index} {...item} />
          ))}
        </div>
        {isOverflowing && (
          <span
            className="text-gray-400 cursor-pointer ml-2 absolute z-10 right-0 top-[50%] translate-y-[-50%]"
            onClick={scrollRight}
          >
            <FontAwesomeIcon
              icon={faArrowAltCircleRight}
              className="mr-2 text-gray-800 hover:text-vb-pink"
            />
          </span>
        )}
      </div>
    </div>
  );
};

export default CreateRail;
